<template>
  <div class="navbar">
    <hamburger id="hamburger-container" :is-active="sidebar.opened" class="hamburger-container" @toggleClick="toggleSideBar" />

<!--    <breadcrumb id="breadcrumb-container" class="breadcrumb-container" v-if="!topNav"/>-->
<!--    <top-nav id="topmenu-container" class="topmenu-container" v-if="topNav"/>-->

    <div class="right-menu">
<!--      <template v-if="device!=='mobile'">-->
<!--        <search id="header-search" class="right-menu-item" />-->

<!--        <el-tooltip content="源码地址" effect="dark" placement="bottom">-->
<!--          <emss-git id="ruoyi-git" class="right-menu-item hover-effect" />-->
<!--        </el-tooltip>-->

<!--        <el-tooltip content="文档地址" effect="dark" placement="bottom">-->
<!--          <emss-doc id="ruoyi-doc" class="right-menu-item hover-effect" />-->
<!--        </el-tooltip>-->

<!--        &lt;!&ndash; <screenfull id="screenfull" class="right-menu-item hover-effect" /> &ndash;&gt;-->

<!--        <el-tooltip content="布局大小" effect="dark" placement="bottom">-->
<!--          <size-select id="size-select" class="right-menu-item hover-effect" />-->
<!--        </el-tooltip>-->

<!--      </template>-->
<!--      <span style="display: inline-block;line-height:50px;vertical-align: top;font-weight:bold;">【{{rowData.name}}】</span>-->
      <el-dropdown class="avatar-container right-menu-item hover-effect" trigger="click">
        <div class="avatar-wrapper">
          <div class="user-avatar">
            <i class="el-icon-s-custom commonTextColor" v-if="rowData.avatar"></i>
            <img src="@/assets/images/icon-logo.png" style="width:32px;height:32px;vertical-align:-6px;" v-else>
          </div>
          <span style="margin-left:2px;font-size:16px;">{{rowData?`${rowData.name}【${rowData.role_name}】`:"--"}}</span>
<!--          <img :src="avatar" class="user-avatar">-->
          <i class="el-icon-caret-bottom"></i>
        </div>
        <el-dropdown-menu slot="dropdown" class="avatar-list">
<!--          <router-link to="/user/profile">-->
<!--            <el-dropdown-item>个人中心</el-dropdown-item>-->
<!--          </router-link>-->
          <el-dropdown-item @click.native="changeRole">
            <span><img src="@/assets/images/icon-role.png" style="margin-right:8px;">角色切换</span>
          </el-dropdown-item>
<!--          <el-dropdown-item divided @click.native="changeThemeColor('1')">-->
<!--            <span>蓝色</span>-->
<!--          </el-dropdown-item>-->
<!--          <el-dropdown-item divided @click.native="changeThemeColor('2')">-->
<!--            <span>红色</span>-->
<!--          </el-dropdown-item>-->
<!--          <el-dropdown-item @click.native="setting = true">-->
<!--            <span>布局设置</span>-->
<!--          </el-dropdown-item>-->
          <el-dropdown-item  @click.native="logout">
            <span><img src="@/assets/images/icon-out.png" style="margin-right:8px;">退出登录</span>
          </el-dropdown-item>
<!--          divided-->
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <!--切换角色-->
    <chooseRoleDiag :roleType="roleType" @closeChooseRoleDiag="closeChooseRoleDiag"></chooseRoleDiag>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import TopNav from '@/components/TopNav'
import Hamburger from '@/components/Hamburger'
// import Screenfull from '@/components/Screenfull'
// import SizeSelect from '@/components/SizeSelect'
// import Search from '@/components/HeaderSearch'
// import EmssGit from '@/components/Emss/Git'
// import EmssDoc from '@/components/Emss/Doc'
import chooseRoleDiag from '../../components/eduCom/chooseRoleDiag.vue'
import {showTip,getSessionData,setSessionData,deleteSessionData} from "@/utils/commonApi";
// import { Login, LoginOut } from "@/utils/login";
export default {
  components: {
    Breadcrumb,
    TopNav,
    Hamburger,
    chooseRoleDiag
    // Screenfull,
    // SizeSelect,
    // Search,
    // EmssGit,
    // EmssDoc
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'avatar',
      'device'
    ]),
    setting: {
      get() {
        return this.$store.state.settings.showSettings
      },
      set(val) {
        this.$store.dispatch('settings/changeSetting', {
          key: 'showSettings',
          value: val
        })
      }
    },
    topNav: {
      get() {
        return this.$store.state.settings.topNav
      }
    }
  },
  data() {
    return {
      roleType:"hidden",
      rowData:getSessionData("roleData"),
    };
  },
  methods: {
    /*改变颜色*/
    changeThemeColor(type){
      if(type ==1){
        sessionStorage.setItem("configInfo", JSON.stringify({theme:"element-variables",commonIndex:'index'}));
        location.reload();
      }else{
        sessionStorage.setItem("configInfo", JSON.stringify({theme:"element-variables1",commonIndex:'index1'}));
        location.reload();
      }
    },
    /*改变角色*/
    changeRole(){
      this.roleType = "change";
    },
    /*关闭弹框*/
    closeChooseRoleDiag(){
      this.roleType = "hidden";
    },
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    },
    async logout() {
      this.$confirm('确定注销并退出系统吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteSessionData("roleData");
        deleteSessionData("menuInfo");
        let localHref = window.location.href;
        let loginOutUrl = "https://sso.aifoodedu.com/?app_id=235956921729810432&redirect_url=" + localHref;
        location.replace(loginOutUrl)
        // LoginOut()
        // this.$store.dispatch('LogOut').then(() => {
        //   location.href = '/index';
        // })
      }).catch(() => {});
    }
  }
}
</script>

<style lang="scss" scoped>
.navbar {
  height: 50px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 3px 1px 4px rgba(0,21,41,.08);

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background .3s;
    -webkit-tap-highlight-color:transparent;

    &:hover {
      background: rgba(0, 0, 0, .025)
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .topmenu-container {
    position: absolute;
    left: 50px;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 16px 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background .3s;

        &:hover {
          background: rgba(0, 0, 0, .025)
        }
      }
    }

    .avatar-container {
      margin-right: 30px;
      .avatar-wrapper {
        /*margin-top: 5px;*/
        position: relative;
        display: flex;
        align-items: center;
        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          //border-radius: 10px;
          text-align: center;
          //border:1px solid #99a9bf;
          i{
            font-size:28px;
            //line-height:40px;
          }
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -12px;
          top: 20px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>
<style lang="scss">
  .avatar-list{
    .el-dropdown-menu__item{
      line-height:40px !important;
    }
  }
</style>
